import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import MfprintingstatusDashboard from '../MfprintingstatusDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function MfprintingstatusPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < MfprintingstatusDashboard />
    )

}